import { cn } from '../../utils/cn'

export function Field({ className, label, hint, error, children }) {
  return (
    <label className={cn('block space-y-1.5', className)}>
      {label ? <span className="text-sm font-semibold text-slate-800">{label}</span> : null}
      {children}
      {error ? <span className="text-xs font-medium text-rose-600">{error}</span> : null}
      {hint && !error ? <span className="text-xs text-slate-500">{hint}</span> : null}
    </label>
  )
}

export function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        'h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-900',
        'placeholder:text-slate-400',
        'shadow-sm shadow-slate-900/5',
        'transition-colors duration-200',
        'focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400',
        'disabled:bg-slate-50 disabled:text-slate-500',
        className
      )}
      {...props}
    />
  )
}

export function Select({ className, children, ...props }) {
  return (
    <select
      className={cn(
        'h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-900',
        'shadow-sm shadow-slate-900/5',
        'transition-colors duration-200',
        'focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400',
        'disabled:bg-slate-50 disabled:text-slate-500',
        className
      )}
      {...props}
    >
      {children}
    </select>
  )
}

export function Textarea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        'min-h-[96px] w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900',
        'placeholder:text-slate-400',
        'shadow-sm shadow-slate-900/5',
        'transition-colors duration-200',
        'focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400',
        className
      )}
      {...props}
    />
  )
}

